import type { ConceptDef } from '../types';

export const receptiveLetters: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-letters',
  label: 'Receptive Letters',
  category: 'Receptive',
  description: 'Hear a letter name and tap the matching letter.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'A', answer: 'A' },
      { say: 'B', answer: 'B' },
      { say: 'C', answer: 'C' },
      { say: 'D', answer: 'D' },
      { say: 'E', answer: 'E' },
      { say: 'F', answer: 'F' },
      { say: 'G', answer: 'G' },
      { say: 'H', answer: 'H' },
    ],
  },
};
